export default __webpack_public_path__ + "static/media/updatePassword@2x.1144079a.jpg";